// extracted by mini-css-extract-plugin
export default {"table":"VerticalSummary_table__qyyt8","value":"VerticalSummary_value__MktJP","underline":"VerticalSummary_underline__7wTtt"};